import LineDiagram from './LineDiagram';

export default LineDiagram;